export const isNullOrBlank = (value) => {
    return !value || value.trim() === '';
};
